<!--智慧安全用电首页-->
<template>
  <div class="zhydHomeBody">
    <!--标题-->
    <div class="zhydTitle">
      <span>智慧式安全用电监测云平台</span>
    </div>
    <div style="width: 90%;margin: 0 auto;height: 80%;display: flex;flex-flow: wrap;justify-content: space-between;">
      <!--服务规模-->
      <div class="fugm">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-size: 20px;color: white;padding-left: 15px;">服务规模</span>
          </div>
          <div style="height: 200px;display: flex;align-items: center;justify-content: space-around;">
            <div class="divCycle1">
              <div class="divCycle2 div-table" style="background: #A7E8BA;">
                <div class="div-cell">
                  <div class="valuepane">{{kanbanCountInfo.user}}</div>
                  <div class="textpane">总用户数</div>
                </div>
              </div>
            </div>
            <div class="divCycle1">
              <div class="divCycle2 div-table" style="background: #A7E8BA;">
                <div class="div-cell">
                  <div class="valuepane">{{nowUnit.watchCount}}</div>
                  <div class="textpane">总监测点数</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <!--运营数据-->
      <div class="yySj">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-size: 20px;color: white;padding-left: 15px;">运营数据</span>
          </div>
          <div
            style="height: 200px;display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
            <div
              style="background: #FFE6C9;height: 70px;width: 95%;display: flex;align-items: center;justify-content: space-around;">
              <span class="textpane">安全运行时间(天)</span>
              <span class="valuepane">{{safeRunningTime}}</span>
            </div>
            <div
              style="background: #FFE6C9;height:70px;width: 95%;display: flex;align-items: center;justify-content: space-around;">
              <span class="textpane">累计发现安全隐患次数</span>
              <span class="valuepane">{{eventCount}}</span>
            </div>
          </div>
        </el-card>
      </div>
      <!--区域接入用户排行-->
      <div class="qyjr">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-size: 20px;color: white;padding-left: 15px;">区域接入用户排行</span>
          </div>
          <div style="height: 200px;">
            <vchart ref='qyphChart'></vchart>
          </div>
        </el-card>
      </div>
      <!--近六月个安全隐患对比分析-->
      <div class="yhdb">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-size: 20px;color: white;padding-left: 15px;">近六月个安全隐患对比分析</span>
          </div>
          <div style="height:300px;">
            <vchart ref='yhdbChart' style='height: 100%;'></vchart>
          </div>
        </el-card>
      </div>
      <!--隐患类型对比分析-->
      <div class="yhlx">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-size: 20px;color: white;padding-left: 15px;">隐患类型对比分析</span>
          </div>
          <div style="height: 300px;display: flex;align-items: center;justify-content: space-around;">
            <div class="yhlxLeft">
              <div class="div-event" style="outline: solid 2px #7CB5EC;">
                <span class="textpane">{{eventTypeList[0].name}}</span>
                <span class="valuepane">{{eventTypeList[0].value}}</span>
              </div>
              <div class="div-event" style="outline: solid 2px #434348;">
                <span class="textpane">{{eventTypeList[1].name}}</span>
                <span class="valuepane">{{eventTypeList[1].value}}</span>
              </div>
              <div class="div-event" style="outline: solid 2px #90ED7D;">
                <span class="textpane">{{eventTypeList[2].name}}</span>
                <span class="valuepane">{{eventTypeList[2].value}}</span>
              </div>
              <div class="div-event" style="outline: solid 2px #F7A35C;">
                <span class="textpane">{{eventTypeList[3].name}}</span>
                <span class="valuepane">{{eventTypeList[3].value}}</span>
              </div>
            </div>
            <div class="yhlxRigth">
              <vchart ref='yhlxChart' style='height: 100%;'></vchart>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
  import vchart from '@/components/module/chart/vchart.vue'
  export default {
    components: {
      vchart,
    },
    props: {},
    data () {
      return {
        kanbanCountInfo: {
          device: 0,
          monitoringPoint: 0,
          user: 0,
        },
        eventCount: 0,
        regionRanking: [], //区域排行数据
        eventList: [],
        eventTypeList: [{
          value: 0,
          name: '过负荷告警',
          typeNos: 1002,
        },
        {
          value: 0,
          name: '高温告警',
          typeNos: 1001
        },
        {
          value: 0,
          name: '剩余电流告警',
          typeNos: 1000
        },
        {
          value: 0,
          name: '电压异常',
          typeNos: 1003
        }
        ],
        barOption: {
          xAxis: [{
            type: 'category',
            data: [],
            axisLabel: {},
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#6f7284'
              }
            },
          }],
          yAxis: [{
            title: '用户数',
            type: 'value',
            axisLabel: {

            },
            splitLine: {},
          }],
          legend: {},
          backgroundColor: '',
          tooltip: {},
          grid: {
            height: '75%',
            left: '1%',
            right: '0',
            bottom: '10%',
            top: '20%',
            containLabel: true
          },
          series: []
        },
        eventOption: {},
        yhlxOption: {
          series: [],
        },
      }
    },
    created () {},
    mounted () {
      this.eventOption=copy(this.barOption)
      this.initDataChart()
      this.$refs.qyphChart.setData(this.barOption)
      this.$refs.yhdbChart.setData(this.eventOption)
      this.$refs.yhlxChart.setData(this.yhlxOption)
      this.initData()
    },
    destroyed () {},
    computed: {
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      nowUnit () {
        console.log(this.$store.unitStore.getters.getNowUnit,'11111');
        //选中的id
        return this.$store.unitStore.getters.getNowUnit
      },
      nowUserInfo () {
        //当前选中的用户
        return this.$store.userStore.state.nowUserInfo
      },
      safeRunningTime () {
        let timeDay=0
        if(!isempty(this.nowUnit.joinTime)) {
          timeDay=((new Date().getTime()-this.nowUnit.joinTime)/1000/60/60/24).toFixed(0)
        }
        return timeDay
      },
      searchAllEventTypes () {
        //事件类型
        return this.$store.eventStore.getters.searchAllEventTypes
      },

    },
    watch: {
      regionRanking (nv,ov) {
        this.initDataChart()
      },
      nowUnit (nv,ov) {
        this.initData()
      },
      eventList (nv,ov) {
        this.initDataChart()
      },
    },
    methods: {
      initDataChart () {
        //初始化图形数据
        let xdata=[]
        let data=[]
        this.regionRanking.forEach(item => {
          xdata.push(item.unitName)
          data.push(item.userCount)
        })
        this.barOption.xAxis[0].data=xdata
        this.barOption.series=[{
          name: '接入用户数',
          type: 'bar',
          barWidth: '60%',
          color: '#975CE0',
          data: data
        }]
        this.$refs.qyphChart.setData(this.barOption)
        //事件数据
        let evetnXdata=[]
        let eventData=[]
        this.eventList.forEach(item => {
          evetnXdata.push(item.dataTime)
          eventData.push(item.eventCount)
        })
        this.eventOption.xAxis[0].data=evetnXdata
        this.eventOption.series=[{
          name: '隐患告警次数',
          type: 'bar',
          barWidth: '60%',
          color: '#2D9FFF',
          data: eventData
        }]
        this.$refs.yhdbChart.setData(this.eventOption)
        this.yhlxOption.tooltip={
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        }
        let legendData=[]
        this.eventTypeList.forEach(item => {
          legendData.push(item.name)
        })
        this.yhlxOption.legend={
          orient: 'vertical',
          left: 'left',
          data: legendData
        }
        this.yhlxOption.color=['rgb(124, 181, 236)','rgb(67, 67, 72)','rgb(144, 237, 125)','rgb(247, 163, 92)']
        this.yhlxOption.series=[{
          name: '隐患类型占比分析',
          type: 'pie',
          radius: '55%',
          center: ['50%','60%'],
          data: this.eventTypeList,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            normal: {
              show: false,
            }
          },

        }]
        this.$refs.yhlxChart.setData(this.yhlxOption)
      },
      eventType () {
        //事件类型图形数据
      },
      initData () {
        //初始化数据
        this.$api.unitApi.getKanbanCountInfo(this.nowUnit.id,respon => {
          this.kanbanCountInfo=respon
        })
        let todayTime=new Date().getTime()
        this.$api.eventApi.countEventListByUser('',this.nowUnit.id,'',-1,'','',0,todayTime,'',respon => {
          this.eventCount=0
          for(var index in respon) {
            respon[index]
            this.eventCount+=respon[index]
          }
        })
        this.$api.unitApi.getLocalUnits(this.nowUnit.id,respon => {
          this.regionRanking=[]
          respon.forEach(item => {
            this.regionRanking.push({
              unitName: item.name,
              userCount: item.userCount
            })
          })
        })
        this.$api.eventApi.countUnitEventsByMonth(todayTime,6,this.nowUnit.id,respon => {
          this.eventList=[]
          respon.forEach(item => {
            this.eventList.push({
              dataTime: new Date(item.time).format('yyyy年MM月'),
              eventCount: item.count
            })
          })
        })
        //查询过负荷告警、高温告警、剩余电流告警、电压异常
        let typeNos='1002,1001,1000,1003'
        this.$api.eventApi.countEventListByUser('',this.nowUnit.id,typeNos,-1,'','','','','',respon => {
          for(let key in respon) {
            this.eventTypeList.forEach(item => {
              if(item.typeNos==key) {
                item.value=respon[key]
              }
            })
          }
        })
      }
    }
  }
</script>

<style>
  .zhydHomeBody {
    background-color: white;
  }

  .zhydTitle {
    height: 15%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .zhydTitle span {
    font-size: .28rem;
    color: #294AFB;
  }

  .fugm {
    width: 25%;
    height: 40%;
  }

  .fugm .el-card__header {
    background-color: #38C245 !important;
  }

  .fugm .el-card {
    border: 1px solid #38C245;
  }

  .yySj {
    width: 33%;
    height: 40%;
  }

  .yySj .el-card__header {
    background-color: #F98C0B !important;
  }

  .yySj .el-card {
    border: 1px solid #F98C0B;
  }

  .qyjr {
    width: 40%;
    height: 40%;
  }

  .qyjr .el-card__header {
    background-color: #975CE0 !important;
  }

  .qyjr .el-card {
    border: 1px solid #975CE0;
  }

  .yhdb {
    width: 59.5%;
    height: 55%;
  }

  .yhdb .el-card__header {
    background-color: #2D9FFF !important;
  }

  .yhdb .el-card {
    border: 1px solid #2D9FFF;
  }

  .yhlx {
    width: 40%;
    height: 55%;
  }

  .yhlx .el-card__header {
    background-color: #FF4747 !important;
  }

  .yhlx .el-card {
    border: 1px solid #FF4747;
  }

  .yhlxLeft {
    height: 100%;
    width: 48%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }

  .yhlxRigth {
    height: 100%;
    width: 48%;
  }

  .div-event {
    width: 100%;
    height: 17%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  /*园样式*/

  .divCycle1 {
    background: rgb(213, 243, 222);
    border-radius: 50%;
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .divCycle2 {
    border-radius: 50%;
    width: 100px;
    height: 100px;
  }

  .div-table {
    display: table;
  }

  .div-cell {
    vertical-align: middle;
    display: table-cell;
    text-align: center;
  }

  .valuepane {
    font-size: 29px;
    text-align: center;
    color: #000000;
  }

  .textpane {
    font-size: 16px;
    text-align: center;
    color: #000000;
  }

  .zhydHomeBody .default-chart {
    height: 200px !important;
  }

  .zhydHomeBody .yhdb .default-chart {
    height: 300px !important;
  }

  .zhydHomeBody .yhlx .default-chart {
    height: 300px !important;
  }
</style>